import React, { useCallback, useEffect } from "react";
import { EventParamTypes } from "../types/types";
import { useDispatch, useSelector } from "react-redux";
import SelectRegistration from "./eventRegistration/views/SelectRegistration";
import { useParams } from "react-router-dom";
import allActions from "../actions/allActions";
import * as eState from "./eventReducer";
import { EventDetailsPage } from "./eventDetails/views/EventDetailsPage";

export const EventPageContainer: React.FC = () => {
  const { id } = useParams<EventParamTypes>();
  const { subEventCreateState } = useSelector(eState.getEventState);
  const dispatch = useDispatch();

  const getEvent = useCallback(() => {
    dispatch(allActions.eventActions.getEvent(id));
  }, [id, dispatch]);

  useEffect(() => {
    getEvent();
  }, [getEvent]);

  return subEventCreateState.selectRegistration ? (
    <SelectRegistration />
  ) : (
    <EventDetailsPage />
  );
};

export default EventPageContainer;
